import styled from 'styled-components';
import Drawer from '../Drawer';

export const StyledTasksDrawer = styled(Drawer)`
  & .main-content {
    flex-direction: row;
    .main-panel {
      flex: 1;
    }
  }

  .checkbox-container {
    margin-top: 20px;
  }

  .highlighted-container {
    margin-top: 20px;
    padding: 10px;
    background-color: #e3f7fc;
    border: 1px solid #7fc5e3;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .ant-drawer-footer {
    display: flex;
    justify-content: space-between;
    align-items: end;
    .options {
      display: flex;
      gap: 0;
      flex-direction: column;
      > * {
        margin-bottom: 6px;
      }
    }
  }
`;
